// test1236
(1236 && 0);
